if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();
      this.zip = this.querySelector('.js-zip-input');
      this.zip.addEventListener('keydown', this.handleZipKeydown.bind(this));
      this.button = this.querySelector('.qls-shipping-calc-button') || this.querySelector('button');
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }

    init() {
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.initialised = true;
    }


    broadcastDeliveryResult(availability, message) {
      const digits = String(this.zip?.value || '').replace(/\D/g, '').slice(0, 9);
      const zip = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      if (!/^\d{5}(?:-\d{4})?$/.test(zip)) return;
      window.dispatchEvent(new CustomEvent('qls:delivery-check-updated', {
        detail: {
          source: `shipping-calculator-${this.dataset.qlsCalculatorId || 'shared'}`,
          result: {
            zip,
            state: '',
            stateCode: '',
            availability,
            message
          }
        }
      }));
    }

    /**
     * Handles submission of the rates calculator.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      evt.preventDefault();
      if (!this.initialised) this.init();

      this.errors.hidden = true;
      this.rates.hidden = true;

      const inlineStatus = this.querySelector('.qls-delivery-inline-status');
      const locationStatus = this.querySelector('.qls-location-status');

      if (inlineStatus) {
        inlineStatus.hidden = true;
        inlineStatus.textContent = '';
        inlineStatus.classList.remove('is-success', 'is-error');
      }

      if (locationStatus) {
        locationStatus.textContent = '';
        locationStatus.classList.remove('is-error');
      }

      this.button.disabled = true;
      this.button.classList.add('is-loading');

      const rawZip = String(this.zip.value || '');
      const requestZip = this.dataset.useFirstFiveZip === 'true' ? rawZip.replace(/\D/g, '').slice(0, 5) : rawZip;
      const params = new URLSearchParams({
        'shipping_address[zip]': requestZip,
        'shipping_address[country]': this.country.value,
        'shipping_address[province]': this.province.value
      }).toString();

      try {
        const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this.showRates(data);
        } else {
          this.showErrors(data);
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
      } finally {
        this.button.classList.remove('is-loading');
        this.button.disabled = false;
      }
    }

    /**
     * Handles keydown event on the zip code input.
     * @param {object} evt - Event object.
     */
    handleZipKeydown(evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        this.handleSubmit(evt);
      }
    }

    /**
     * Formats and shows a list of available shipping rates.
     * @param {object} data - Response data.
     */
    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      const inlineStatus = this.querySelector('.qls-delivery-inline-status');
      textEl.innerHTML = '';

      if (this.dataset.ratesMode === 'availability') {
        this.rates.hidden = true;

        if (inlineStatus) {
          inlineStatus.hidden = false;
          inlineStatus.classList.remove('is-success', 'is-error');

          if (data.shipping_rates && data.shipping_rates.length) {
            inlineStatus.textContent = 'Delivery available';
            inlineStatus.classList.add('is-success');
            this.broadcastDeliveryResult('success', 'Delivery available.');
          } else {
            inlineStatus.textContent = 'We do not ship to this location';
            inlineStatus.classList.add('is-error');
            this.broadcastDeliveryResult('error', 'We do not ship to this location.');
          }
        }

        return;
      }

      if (data.shipping_rates && data.shipping_rates.length) {
        headingEl.hidden = false;
        const headingLocaleStr = data.shipping_rates.length === 1 ? 'singleRate' : 'multipleRates';
        let rates = '';

        data.shipping_rates.forEach((rate) => {
          const formattedRate = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, rate.price);
          rates += `<li>${rate.name}: ${formattedRate}</li>`;
        });

        headingEl.textContent = theme.strings.shippingCalculator[headingLocaleStr];
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = theme.strings.shippingCalculator.noRates;
      }

      this.rates.hidden = false;
    }

    /**
     * Formats and shows errors relating to rates retrieval.
     * @param {object} data - Response data.
     */
    showErrors(data) {
      const inlineStatus = this.querySelector('.qls-delivery-inline-status');

      if (this.dataset.ratesMode === 'availability' && inlineStatus) {
        this.errors.hidden = true;
        inlineStatus.hidden = false;
        inlineStatus.textContent = 'We do not ship to this location';
        inlineStatus.classList.remove('is-success');
        inlineStatus.classList.add('is-error');
        this.broadcastDeliveryResult('error', 'We do not ship to this location.');
        return;
      }

      let errors = '';

      Object.keys(data).forEach((key) => {
        errors += `<li>${data[key]}</li>`;
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);
}
